import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Vat } from '../common/Vat';
import { ApiServiceBase } from './ApiServiceBase';

@Injectable({
  providedIn: 'root'
})
export class VatService extends ApiServiceBase {
  protected readonly path = 'vat';
  
  get(): Observable<Vat[]> {
    return this.http.get<Vat[]>(this.getUrl());
  }
}
